import { Stack } from 'expo-router';
import type { ExtendedStackNavigationOptions } from 'expo-router/build/layouts/StackClient';
import { FormProvider, useForm } from 'react-hook-form';
import { StyleSheet, withUnistyles } from 'react-native-unistyles';
import Box from '@/components/Unistyles/Box';
import WelcomeHeaderActions from '@/components/Welcome/WelcomeHeaderActions';
import { createWelcomeFormDefaultValues, type WelcomeFormValues } from './form';

type WelcomeRouteScreenOption = {
  name: string;
  options: ExtendedStackNavigationOptions;
};

const WELCOME_ROUTE_SCREEN_OPTIONS: WelcomeRouteScreenOption[] = [
  {
    name: 'index',
    options: { headerShown: false, title: 'Welcome' },
  },
  {
    name: 'profile',
    options: { headerBackTitle: 'Welcome', title: 'Profile' },
  },
  {
    name: 'persona',
    options: { headerBackTitle: 'Profile', title: 'Role' },
  },
  {
    name: 'join',
    options: { headerBackTitle: 'Setup', title: 'Join' },
  },
  {
    name: 'team/index',
    options: { headerBackTitle: 'Role', title: 'Team Setup' },
  },
  {
    name: 'team/create',
    options: { headerBackTitle: 'Team Setup', title: 'Create Team' },
  },
  {
    name: 'org/index',
    options: { headerBackTitle: 'Role', title: 'Organization' },
  },
  {
    name: 'org/league-season',
    options: { headerBackTitle: 'Organization', title: 'League & Season' },
  },
  {
    name: 'org/teams',
    options: { headerBackTitle: 'League & Season', title: 'Teams' },
  },
  {
    name: 'org/schedule/slots',
    options: { headerBackTitle: 'Teams', title: 'Game Weeks' },
  },
  {
    name: 'org/schedule/options',
    options: { headerBackTitle: 'Game Weeks', title: 'Schedule Options' },
  },
  {
    name: 'org/schedule/preview',
    options: { headerBackTitle: 'Schedule Options', title: 'Review Games' },
  },
  {
    name: 'done',
    options: { headerBackTitle: 'Setup', title: 'Finish' },
  },
];

const WelcomeStack = withUnistyles(Stack, (theme) => ({
  screenOptions: {
    contentStyle: {
      backgroundColor: theme.colors.background,
    },
    headerShadowVisible: false,
    headerStyle: {
      backgroundColor: theme.colors.background,
    },
    headerRight: () => <WelcomeHeaderActions />,
    headerTintColor: theme.colors.typography,
    headerTitle: '',
  },
}));

export default function WelcomeLayout() {
  const form = useForm<WelcomeFormValues>({
    defaultValues: createWelcomeFormDefaultValues(),
    mode: 'onChange',
  });

  return (
    <FormProvider {...form}>
      <Box flex style={style.container}>
        <WelcomeStack>
          {WELCOME_ROUTE_SCREEN_OPTIONS.map((screen) => (
            <Stack.Screen
              key={screen.name}
              name={screen.name}
              options={screen.options}
            />
          ))}
        </WelcomeStack>
      </Box>
    </FormProvider>
  );
}

const style = StyleSheet.create((theme, rt) => ({
  container: {
    backgroundColor: theme.colors.background,
    paddingBottom: rt.insets.bottom,
  },
}));
